import React from 'react'
import TopBarProgress from "react-topbar-progress-indicator";

TopBarProgress.config({
  barColors: {
    "0": "#ef6c00",
    "1.0": "#ef6c00"
  },
  shadowBlur: 5
});

export const ProgressIndicator = () => {
  return <div className="loading-spinner-wrapper"><TopBarProgress /></div>;
};
